import get from 'lodash.get';

const getRewardful = () => window.Rewardful;

export const getReferral = (rw = getRewardful) => {
  const r = rw();
  if (!r) {
    return '';
  }

  return get(r, 'referral', '');
};

export const getAffiliate = (rw = getRewardful) => {
  const r = rw();
  if (!r) {
    return '';
  }

  return get(r, 'affiliate.name', '');
};
